export default "__VITE_ASSET__CVuW3OX___"